import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';

import CaseSounds from './CaseSounds.vue';
import queries from '~lib/common/queries/Sound';

const enhance = compose(dataView({ queries }), renameProps({ data: 'sounds' }));

export default enhance(CaseSounds);
